// 大气监测
<template>
  <div class="main-middle" v-if="isRefresh">
    <div class="eqmtabs">
      <div class="tabsL">
        <el-tabs v-model="timeClass" style="margin-left: 10px, margin-bottom: 0" @tab-click="tabClick">
          <el-tab-pane label="  小时  " name="hourly"></el-tab-pane>
          <el-tab-pane label="  天  " name="daily"></el-tab-pane>
          <el-tab-pane label="  月  " name="monthly"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="tabsR">
        <el-tabs v-model="typeTab" style="margin-left: 10px, margin-bottom: 0">
          <el-tab-pane label="  表格  " name="table"></el-tab-pane>
          <el-tab-pane label="  图形  " name="chart"></el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div>
      <div v-show="typeTab == 'table'">
        <div style="text-align: left;">
          <el-button class=btn type="primary" size="mini" @click="addRow">新增</el-button>
          <!-- <el-button class=btn type="primary" size="mini" @click="deleteMany" style="width: 88px; height: 36px;">批量删除</el-button> -->
          <el-button class=btn type="primary" size="mini" @click="handleRefresh" style="width: 88px; height: 36px;" icon="el-icon-refresh-right">刷新</el-button>
        </div>
        <div style="width: 100%">
          <table width="100%" border="1" class="mntTable" align="center">
            <tr>
              <th width="4%" class="cell thtitle">序号</th>
              <th width="12%" class="cell thtitle">时间</th>
              <th class="cell thtitle">用水量 (m3)</th>
              <th width="12%" class="cell thtitle">操作</th>
            </tr>
            <tr v-for="(item, index) in eqmUwaterData" :key="index">
              <td class="cell tdcell">{{index+1}}</td>
              <td class="cell tdcell">
                <el-input v-if="item.editFlag" v-model="item.eqmTime" type="datetime-local"></el-input>
                <span v-else>{{item.eqmTime}}</span>
              </td>
              <td class="cell tdcell">
                <el-input v-if="item.editFlag" v-model="item.eqmuUsage"></el-input>
                <span v-else>{{item.eqmuUsage}}</span>
              </td>
              <td class="cell tdcell">
                <el-button type="text" size="mini" @click="editRow(item)">编辑</el-button>
                <el-button type="text" size="mini" @click="saveRow(item)">保存</el-button>
                <el-button type="text" size="mini" @click="deleteRow(item)">删除</el-button>
              </td>
            </tr>
          </table>
        </div>
        <div class="bottom-pagination">
          <el-pagination
            hide-on-single-page
            small
            background
            layout="prev, pager, next, jumper"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :current-page="currentPage"
            :total="totalNumber">
          </el-pagination>
        </div>
      </div>
      <div class="highcharts-container" v-show="typeTab == 'chart'" style="width: 100%">
        <div style="width: 100%; height: 500px; flex: none;">
          <highcharts id="highcharts" :options="showChart1"></highcharts>
        </div>
        <!-- <div style="width: 50%; height: 500px; flex: none;">
          <highcharts :options="showChart2"></highcharts>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../../api/index'
export default {
  props: ['markerOrder'],
  data () {
    return {
      timeClass: 'hourly',
      typeTab: 'table',
      isRefresh: true,
      eqmUwaterData: [{
        order: 0,
        eqmTime: 'yyyy-MM-dd hh:mm:ss',
        eqmuUsage: null,
        editFlag: false
      }],
      //   order: 1,
      //   eqmTime: '2021-9-22 10:00',
      //   eqmuUsage: 4,
      //   editFlag: false
      // }, {
      //   order: 2,
      //   eqmTime: '2021-9-22 11:00',
      //   eqmuUsage: 4,
      //   editFlag: false
      // }, {
      //   order: 3,
      //   eqmTime: '2021-9-22 12:00',
      //   eqmuUsage: 3,
      //   editFlag: false
      // }, {
      //   order: 4,
      //   eqmTime: '2021-9-22 13:00',
      //   eqmuUsage: 5,
      //   editFlag: false
      // }],
      pageSize: 10,
      currentPage: 1,
      totalNumber: 10
    }
  },
  mounted () {
    this.getEQMUwater()
  },
  computed: {
    showChart1: function () {
      this.chartInit()
      return this.chartOptions1
    }
    // showChart2: function () {
    //   this.chartInit()
    //   return this.chartOptions1
    // }
  },
  methods: {
    tabClick () {
      this.$nextTick(() => {
        this.getEQMUwater()
      })
    },
    getEQMUwater (pageNo = 1) {
      console.log(this.markerOrder)
      api.hbOnlineEnquiry({
        pages: 10,
        pageNo: pageNo,
        onlineId: this.markerOrder
      }).then(res => {
        console.log('res', res.data)
        this.totalNumber = res.data.totalNumber
        var tempArr = []
        var uwaterData = res.data.uwater
        uwaterData[this.timeClass].forEach(item => {
          var enquiryPusher = {}
          enquiryPusher.order = item.id
          if ('time' in item) { enquiryPusher.eqmTime = item.time } else { enquiryPusher.eqmTime = '' }
          if ('uwater' in item) { enquiryPusher.eqmuUsage = item.uwater } else { enquiryPusher.eqmuUsage = 0 }
          enquiryPusher.editFlag = false
          tempArr.push(enquiryPusher)
        })
        // if (this.timeClass === 'hourly') {
        //   uwaterData[this.timeClass].forEach(item => {
        //     tempArr.push({
        //       order: item.id,
        //       eqmTime: item.time,
        //       eqmuUsage: item.uwater,
        //       editFlag: false
        //     })
        //   })
        // } else if (this.timeClass === 'daily') {
        //   uwaterData[this.timeClass].forEach(item => {
        //     tempArr.push({
        //       order: item.id,
        //       eqmTime: item.time,
        //       eqmuUsage: item.uwater,
        //       editFlag: false
        //     })
        //   })
        // } else if (this.timeClass === 'monthly') {
        //   uwaterData[this.timeClass].forEach(item => {
        //     tempArr.push({
        //       order: item.id,
        //       eqmTime: item.time,
        //       eqmuUsage: item.uwater,
        //       editFlag: false
        //     })
        //   })
        // }
        this.eqmUwaterData = tempArr
        console.log('eqmUwaterData', this.eqmUwaterData)
        this.chartInit()
      })
    },
    addRow () {
      var addPusher = {}
      addPusher.onlineId = this.markerOrder
      addPusher.time = ''
      addPusher.uwater = 0
      api.hbOnlineAdd(addPusher).then(res => {
        console.log(res)
        this.$nextTick(function () {
          this.getEQMUwater(this.currentPage)
        })
      })
    },
    editRow (row) {
      console.log('editRow')
      row.editFlag = true
    },
    saveRow (row) {
      console.log('saveRow')
      row.editFlag = false
      var savePusher = {}
      savePusher.id = row.order
      var plsscd = ''
      if (row.eqmTime.length === 16) { plsscd = ':00' }
      if (row.eqmTime) { savePusher.time = row.eqmTime.replace('T', ' ') + plsscd } else { savePusher.time = '' }
      if (row.eqmuUsage) { savePusher.uwater = row.eqmuUsage } else { savePusher.uwater = 0 }
      console.log('savePusher', savePusher)
      api.hbOnlineUpdate(savePusher).then(res => {
        console.log(res)
        this.$nextTick(function () {
          this.getEQMUwater(this.currentPage)
        })
      })
    },
    deleteRow (row) {
      this.deleteArr = row
      console.log(this.deleteArr)
      api.hbOnlineDelete({
        id: row.order
      }).then(res => {
        console.log(res)
        this.getEQMUwater()
      })
    },
    // deleteMany () {
    //   this.deleteData()
    // },
    // deleteData () {
    //   var strData = ''
    //   this.deleteArr.forEach(element => {
    //     strData = strData + element.order + ','
    //   })
    //   this.deleteCheckData(strData)
    //   console.log(strData)
    // },
    // deleteCheckData (strId) {
    //   api.eiaBusinessDelete({
    //     id: strId
    //   }).then(res => {
    //     console.log(res)
    //     this.getCustomerment(this.currentPage)
    //   })
    // },
    handleRefresh () {
      this.isRefresh = false
      this.$nextTick(function () {
        this.isRefresh = true
        this.getEQMUwater(this.currentPage)
      })
    },
    handleCurrentChange (currentPage) {
      this.currentPage = currentPage
      this.getEQMUwater(this.currentPage)
    },
    table_index (index) {
      return (this.currentPage - 1) * this.pageSize + index + 1
    },
    chartInit () {
      var chartSeriesDatas = {
        xDates: { name: '时间', data: [] },
        xUsage: { name: '用水量', data: [] }
      }
      this.eqmUwaterData.forEach(element => {
        chartSeriesDatas.xDates.data.push(element.eqmTime)
        chartSeriesDatas.xUsage.data.push(element.eqmuUsage)
      })
      console.log('chartSeriesDatas', chartSeriesDatas)
      var chartSeries = []
      chartSeries.push(
        chartSeriesDatas.xUsage
      )
      this.chartOptions1 = {
        title: {
          text: '用水量 (m3)'
        },
        credits: {
          enabled: false
        },
        // subtitle: {
        //   text: ''
        // },
        xAxis: {
          categories: chartSeriesDatas.xDates.data
        },
        yAxis: {
          title: {
            text: 'm3'
          },
          allowDecimals: true
        },
        tooltip: {
          enabled: true,
          valueDecimals: 1
        },
        legend: {
          layout: 'vertiacal',
          align: 'right',
          verticalAlign: 'bottom'
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false
            }
          }
        },
        series: chartSeries,
        responsive: {
          rules: [{
            condition: {
              maxWidth: 480
            },
            chartOptions: {
              legend: {
                layout: 'horizontal',
                align: 'center',
                veticalAlign: 'bottom'
              }
            }
          }]
        }
      }
    }
  }
}
</script>

<style lang="scss">
.main-middle {
      flex: 1 1 50%;
      display: flex;
      flex-direction: column;
      position: relative;
      overflow: auto;
      .eqmtabs{
        display: flex;
        .tabsL{
          flex: 7;
        }
        .tabsR{
          flex: 1;
          text-align: right;
        }
      }
      .mntDetailTable {
        flex: 1;
        position: relative;
        overflow-y: scroll;
        border-radius: 4px;
        width: calc(95% - 10px);
        /deep/ .el-table__fixed-right {
          height: 100% !important; //设置高优先，以覆盖内联样式
        }
        /deep/ .el-table--scrollable-x .el-table__body-wrapper {
          overflow: auto !important;
        }
        /deep/.el-table__fixed-right-patch {
          background-color: #f5f7fa !important;
        }
        // /deep/ .el-table__fixed {
        //   height: 100% !important; //设置高优先，以覆盖内联样式
        // }
        .el-input__inner{
          height: 24px!important;
        }
        .el-icon-time{
          margin-top: -2px!important;
        }
      }
      .topsearchForm {
        padding-left: 20px;
        margin-bottom: 15px;
        margin-top: 5px;
        .el-form-item {
          margin-bottom: 0px
        }
      }
    }
    .btn-menu .el-button {
      margin-bottom: 10px!important;
      margin-left: 10px;
    }
    .bottom-pagination .el-pagination {
      text-align: right;
      margin-top: 6px;
      margin-bottom: 6px;
    }
    .el-dialog .dialog-form {
      width: 70%;
      margin: auto;
    }
    .btn{
      width: 88px;
      height: 36px;
      margin: 0 5px 5px 5px!important;
    }
    // .highcharts-root{
    //   height: 500px
    // }
    .highcharts-container {
      display: flex;
      width: 100%;
      height: 100%;
    }
    // #highcharts-11futo9-0{
    //   height: 500px;
    // }
    #highcharts{
      height: 100%;
    }
</style>
